<template>
	<div class="height-100dvh">
		<div
			id="hideinlaptop"
			class="jobmob-header mob-back-header d-flex align-items-center justify-content-between"
		>
			<div class="d-flex align-items-center">
				<img
					class="mr-3"
					src="../../assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
					@click="goBack"
				/>
				Job Match
			</div>
		</div>
		<main
			class="job-match-container spinner-height position-relative"
			v-if="!jobLoader"
		>
			<!-- <b-skeleton type="Input" class="w-100 h-100"></b-skeleton> -->
			<Spinner :id="'jobmatch'" class="w-100 h-100"></Spinner>
		</main>
		<main class="job-match-container app-bottom-padding" v-else>
			<section class="jobmt-bluebox">
				<div class="d-flex flex-column align-items-center position-relative">
					<img
						src="../../assets/newdesign/jobsearch/JobMatch/4colorMeter.svg"
						alt=""
					/>
					<img
						:class="dialClass"
						src="../../assets/newdesign/jobsearch/JobMatch/blackDial.svg"
						alt=""
					/>
					<span class="mt-3 text-darkgrey fs-18 fw-B fam-lato">{{
						jobRating
					}}</span>
				</div>
				<div class="jobmt-row-width" v-if="jobLoader">
					<b-row class="m-0">
						<b-col
							class="px-0 py-2"
							:class="index % 2 == 1 ? 'pl-2' : ''"
							cols="6"
							v-for="(JobMatchFields, index) in JobMatchFields"
							:key="index"
						>
							<span class="d-flex align-items-center gap-1 jobmt-italic-txt">
								<img
									v-if="isRelevant(JobMatchFields)"
									src="../../assets/newdesign/jobsearch/JobMatch/relevant.svg"
									alt="Relevant"
								/>
								<img
									v-else
									src="../../assets/newdesign/jobsearch/JobMatch/notRelevant.svg"
									alt="Not Relevant"
								/>
								{{ JobMatchFields }}
							</span>
						</b-col>
					</b-row>
				</div>
			</section>
			<section
				class="d-flex justify-content-between align-items-center jobmt-padding"
			>
				<span class="fs-16 fw-M fam-lato text-grey">Brief Overview:</span>
				<div
					id="hideinmobile"
					class="d-flex justify-content-between align-items-center gap-4 text-darkgrey fam-lato fs-12 fw-M"
				>
					<article class="d-flex align-items-center gap-2">
						<div class="jobmt-green-box"></div>
						<span>Amazing</span>
					</article>
					<article class="d-flex align-items-center gap-2">
						<div class="jobmt-yellow-box"></div>
						<span>Good</span>
					</article>
					<article class="d-flex align-items-center gap-2">
						<div class="jobmt-orange-box"></div>
						<span>Okay</span>
					</article>
					<article class="d-flex align-items-center gap-2">
						<div class="jobmt-red-box"></div>
						<span>Fair</span>
					</article>
				</div>
			</section>

			<section
				id="hideinmobile"
				class="jobmt-header text-darkgrey fam-mont fs-14 fw-M"
			>
				<div class="one pl-4">Category</div>
				<div class="two">Status</div>
				<div class="three">Comments</div>
			</section>

			<section class="jobmt-overflow">
				<article
					v-for="(jobmatch, index) in filteredJobMatchData"
					:key="index"
					class="jobmt-rows"
				>
					<div class="blue-line"></div>
					<div id="hideinmobile" class="one pl-4">
						{{ getOriginalName(jobmatch.criteria) }}
					</div>
					<div id="hideinmobile" class="two">
						<div
							:class="{
								'jobmt-green-box':
									jobmatch.rating >= 8 && jobmatch.rating <= 10,
								'jobmt-yellow-box':
									jobmatch.rating >= 6 && jobmatch.rating <= 7,
								'jobmt-orange-box':
									jobmatch.rating >= 4 && jobmatch.rating <= 5,
								'jobmt-red-box': jobmatch.rating <= 3,
							}"
						></div>
					</div>
					<div class="three">
						<div>
							<h4 id="hideinlaptop" class="text-darkgrey fs-14 fw-LM fam-lato">
								{{ getOriginalName(jobmatch.criteria) }}
							</h4>
							<div class="d-inline">
								<span class="">{{ jobmatch.suggestion }}</span>
								<!-- <span class="ml-2 text-primary">...show more</span> -->
							</div>
						</div>
						<div
							id="hideinlaptop"
							v-if="jobmatch.rating >= 8 && jobmatch.rating <= 10"
							class="jobmt-greentag"
						>
							AMAZING
						</div>
						<div
							id="hideinlaptop"
							v-else-if="jobmatch.rating >= 6 && jobmatch.rating <= 7"
							class="jobmt-orangetag"
						>
							GOOD
						</div>
						<div
							id="hideinlaptop"
							v-else-if="jobmatch.rating >= 4 && jobmatch.rating <= 5"
							class="jobmt-yellowtag"
						>
							OKAY
						</div>
						<div id="hideinlaptop" v-else class="jobmt-redtag">FAIR</div>
					</div>
				</article>
			</section>
		</main>
	</div>
</template>

<script>
import { getJobMatch } from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import Spinner from "../fixedcomponents/Spinner.vue";
export default {
	props: {
		job: {
			type: Object,
			required: true,
		},
	},
	components: {
		Spinner,
	},
	data() {
		return {
			loopvar: 10,
			JobMatchFields: [
				"Relevance of Experience",
				"Educational Relevance",
				"Career Progression",
				"Gaps in Experience",
				"Industry Knowledge",
				"Cultural Fit",
			],
			jobMatchData: [],
			jobLoader: false,
			originalName: {
				personal_detail: "Personal Info",
				educationalInfo: "Education",
				experience: "Experience",
				skills: "Skills",
				projects: "Projects",
				achievement_and_portfolio: "Achievements & Portfolio",
				overall: "Overall Match",
			},
			overallRating: 0,
			jobRating: "Fair",
		};
	},
	created() {
		this.getJobMatch();
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
		}),
		filteredJobMatchData() {
			return this.jobMatchData.filter(
				(jobmatch) => jobmatch.criteria !== "overall"
			);
		},
		dialClass() {
			if (this.jobRating == "Fair") return "dial-pos-red";
			if (this.jobRating == "Good") return "dial-pos-yellow";
			if (this.jobRating == "Okay") return "dial-pos-orange";
			if (this.jobRating == "Amazing") return "dial-pos-green";
			return "dial-pos-red";
		},
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		async getJobMatch() {
			const data = {
				job: this.job,
				candidate: this.candidateInfo,
			};
			const response = await getJobMatch(data);
			if (response.status == 200) {
				this.jobLoader = true;
				this.jobMatchData = response.data.data;
				this.overallRating =
					this.jobMatchData[this.jobMatchData.length - 1].rating;
				if (this.overallRating >= 8) {
					this.jobRating = "Amazing";
				} else if (this.overallRating >= 6) {
					this.jobRating = "Good";
				} else if (this.overallRating >= 4) {
					this.jobRating = "Okay";
				} else {
					this.jobRating = "Fair";
				}
			}
		},

		isRelevant(field) {
			if (this.jobMatchData.length === 0) return false;
			const lastJobMatch = this.jobMatchData[this.jobMatchData.length - 1];
			const fieldMapping = {
				"Relevance of Experience": "relavent_experience",
				"Educational Relevance": "relavent_education",
				"Career Progression": "relavent_experience",
				"Gaps in Experience": "relavent_experience",
				"Industry Knowledge": "relavent_industry_or_domain",
				"Cultural Fit": "relavent_industry_or_domain",
			};

			const fieldKey = fieldMapping[field];
			return lastJobMatch && lastJobMatch[fieldKey];
		},

		getOriginalName(criteria) {
			return this.originalName[criteria] || criteria;
		},
	},
};
</script>

<style>
.job-match-container {
	background-color: #ffffff;
}

.spinner-height {
	height: calc(100vh - 180px);
}

.jobmt-bluebox {
	background-color: #f6f8fb;
	border-radius: 8px;
	padding: 20px;
	padding-left: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.dial-pos-red {
	position: absolute;
	bottom: 37px;
	right: 58px;
	transform: rotate(-131deg);
	transform-origin: center;
}
.dial-pos-orange {
	position: absolute;
	bottom: 48.5px;
	right: 44px;
	transform: rotate(-87deg);
	transform-origin: center;
}
.dial-pos-yellow {
	position: absolute;
	bottom: 46.5px;
	right: 27px;
	transform: rotate(-43deg);
	transform-origin: center;
}
.dial-pos-green {
	position: absolute;
	bottom: 33px;
	right: 15px;
	transform: rotate(1deg);
	transform-origin: center;
}

.jobmt-row-width {
	width: 65%;
}
.jobmt-red-box {
	height: 12px;
	width: 12px;
	background-color: #eb0002;
	border-radius: 3px;
}
.jobmt-orange-box {
	height: 12px;
	width: 12px;
	background-color: #e99e32;
	border-radius: 3px;
}
.jobmt-yellow-box {
	height: 12px;
	width: 12px;
	background-color: #f9c82b;
	border-radius: 3px;
}
.jobmt-green-box {
	height: 12px;
	width: 12px;
	background-color: #2aa869;
	border-radius: 3px;
}
.jobmt-header {
	display: flex;
	background-color: #ecf1fc;
	border-radius: 5px;
	padding: 10px;
	margin-inline: 4px;
}
.jobmt-header .one {
	width: 20%;
}
.jobmt-header .two {
	width: 20%;
	display: flex;
	justify-content: center;
}
.jobmt-header .three {
	width: 60%;
}
.jobmt-rows {
	display: flex;
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	margin-top: 10px;
	border-radius: 5px;
	padding: 5px;
	position: relative;
	color: #333333;
	font-family: "lato", sans-serif;
	font-size: 13px;
	font-weight: 500;
}
.jobmt-rows .blue-line {
	width: 4px;
	height: 90%;
	background-color: var(--bg-proTheme);
	border-radius: 2px;
	position: absolute;
	left: 4px;
	top: 5%;
}
.jobmt-rows .one {
	width: 20%;
	padding-top: 5px;
	padding-left: 29px;
}
.jobmt-rows .two {
	width: 20%;
	display: flex;
	justify-content: center;
	align-items: flex-start;
	height: 100%;
	padding-top: 10px;
}
.jobmt-rows .three {
	width: 60%;
	padding: 5px;
}
.jobmt-overflow {
	height: calc(100vh - 424px);
	overflow: auto;
	padding: 4px;
}

.jobmt-italic-txt {
	font-family: "Montserrat", sans-serif;
	font-size: 12px;
	font-style: italic;
	font-weight: 600;
	color: #333333;
}
.jobmt-padding {
	padding: 10px 0;
}
@media (max-width: 1028px) {
	.jobmob-header {
		top: unset !important;
		padding-top: env(safe-area-inset-top) !important;
	}
	.mob-jobmatch-container {
		height: calc(100dvh - 65px);
		position: relative;
		top: 60px;
	}
	.jobmt-bluebox {
		padding: 10px;
		padding-top: 20px;
		padding-left: 10px;
		flex-direction: column;
	}
	.jobmt-row-width {
		width: 100%;
	}
	.job-match-container {
		border-radius: 8px;
		height: calc(
			100dvh - (60px + env(safe-area-inset-top) + env(safe-area-inset-bottom))
		);
		top: unset;
		/* position: fixed; */
		overflow: auto;
		background-color: #e9ecef;
		padding: 15px;
		width: 100%;
	}
	.jobmt-italic-txt {
		font-size: 11px;
	}
	.jobmt-padding {
		padding: 10px 10px 0 10px;
	}
	.jobmt-rows .three {
		width: 100%;
		padding: 5px 11px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.jobmt-rows {
		color: #5b5b5b;
		font-family: "lato", sans-serif;
		font-size: 12px;
		font-weight: 600;
	}
	.jobmt-greentag {
		background-color: #038e001a;
		border-radius: 4px;
		font-family: "Lato", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: #038e00;
		padding: 2px 13px;
		margin-left: 20px;
	}
	.jobmt-redtag {
		background-color: #d7342c1a;
		border-radius: 4px;
		font-family: "Lato", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: #d7342c;
		padding: 2px 13px;
		margin-left: 20px;
	}
	.jobmt-yellowtag {
		background-color: #f9c82b1a;
		border-radius: 4px;
		font-family: "Lato", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: #f9c82b;
		padding: 2px 13px;
		margin-left: 20px;
	}
	.jobmt-orangetag {
		background-color: #f9c82b1a;
		border-radius: 4px;
		font-family: "Lato", sans-serif;
		font-size: 12px;
		font-weight: 600;
		color: orange;
		padding: 2px 13px;
		margin-left: 20px;
	}
	.three-line-truncate {
		word-break: break-word;
		word-wrap: break-word;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;

		@supports (-webkit-line-clamp: 2) {
			display: -webkit-box !important;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: normal;
			-webkit-line-clamp: 3;
		}
	}
	.jobmt-overflow {
		height: unset;
		overflow: unset;
		padding: 0 0px 10px 0px;
	}
}
</style>
